<template>
  <section class="d-flex flex-column px-5 pt-5">
    <b-input-group class="mb-2 dir-ltr">
      <b-input-group-text slot="prepend">
        <img v-b-tooltip.hover :alt="$t('UserProfile.Demographic.UserName')" :title="$t('UserProfile.Demographic.UserName')" height="24" src="@/assets/icons/user-card.svg">
      </b-input-group-text>
      <b-form-input v-model="user.UserName" :placeholder="$t('UserProfile.Demographic.UserName')" />
    </b-input-group>
    <b-input-group class="mb-2 dir-ltr">
      <b-input-group-text slot="prepend">
        <img v-b-tooltip.hover :alt="$t('UserProfile.Demographic.Email')" :title="$t('UserProfile.Demographic.Email')" height="24" src="@/assets/icons/email.svg">
      </b-input-group-text>
      <b-form-input v-model="user.Email" type="email" :placeholder="$t('UserProfile.Demographic.Email')" />
    </b-input-group>
    <b-input-group class="mb-2 dir-ltr">
      <b-input-group-text slot="prepend">
        <img v-b-tooltip.hover :alt="$t('UserProfile.Demographic.CellPhone')" :title="$t('UserProfile.Demographic.CellPhone')" height="24" src="@/assets/icons/phone.svg">
      </b-input-group-text>
      <b-form-input v-model="user.Cellphone" type="tel" :placeholder="$t('UserProfile.Demographic.CellPhone')" />
    </b-input-group>
    <div class="d-flex flex-row justify-content-end">
      <a href="#" class="text-decoration-none text-dark align-self-start align-content-center my-3 mx-5 lead" @click="HideEditUserAccountForm()">
        <img height="30" class="bidi-icon" src="@/assets/icons/back.svg">
        {{ $t('common.cancel') }}
      </a>

      <b-button variant="success" size="lg" class="px-5">
        {{ $t('UserProfile.Commands.SubmitChanges') }}
      </b-button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'UserProfileEditUserAccount',
  props: {
    user: Object
  },
  methods: {
    HideEditUserAccountForm () {
      this.$emit('HideEditUserAccountForm')
    }
  }
}
</script>
